/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useNavigate, useLocation } from 'react-router-dom'

import { noriCombinations } from '../../query/nori/nori.query'
import { getCurrentPoolData } from '../../query/home/home.query'
import ScrollTop from '../../config/scroll'
import Header from '../../components/Header'
import Footer from '../../components/footer'
import Sidebar from '../../components/Sidebar'
import Loading from '../../components/Loader'
import FirstComponent from '../Nori/Step-Components/FirstComponent'
import SecondComponent from '../Nori/Step-Components/SecondComponent'
import ThirdComponent from '../Nori/Step-Components/ThirdComponent'
import FourthComponent from '../Nori/Step-Components/FourthComponent'
import FifthComponent from '../Nori/Step-Components/FifthComponent'
import SixthComponent from '../Nori/Step-Components/SixthComponent'
import SeventhComponent from '../Nori/Step-Components/SeventhComponent'
import EightComponent from '../Nori/Step-Components/EightComponent'
import NinthComponent from '../Nori/Step-Components/NinthComponent'
import { useTranslation } from 'react-i18next'

import '../../assets/sass/views/Nori.scss'
import '../../assets/sass/views/Home.scss'
import blueballimg from '../../assets/images/blue-ball-img.png'
import redballimg from '../../assets/images/red-ball-img.png'

const Sell = (props) => {
  const { t } = useTranslation('global')
  const { state } = useLocation()
  const navigate = useNavigate()
  const ncbTickets = state?.ncbTickets
  const stepsTickets = state?.stepsTickets ? state.stepsTickets : '[]'
  const [loading, setLoading] = useState({ status: true })
  const [homeData, setHomeData] = useState({})
  const [isFetch, setIsFetch] = useState(false)
  const [noriPFactorData, setNoriPFactorData] = useState([])
  const [noriStatus, setNoriStatus] = React.useState({ status: 'inActive' })
  const [prevActiveStep, setPrevActiveStep] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoading({ status: false })
    }, 200)
    if (state === null) { setIsFetch(true) }
  }, [])

  useQuery(['current-pool', isFetch], getCurrentPoolData, {
    select: (data) => {
      return data?.data
    },
    onSuccess: async (data) => {
      if (!state) setHomeData(data)
      setIsFetch(false)
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: t('views.sellNori.error') } })
    }
  })

  const firstComponent = () => {
    return (
      <FirstComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={2} />
    )
  }
  const secondComponent = () => {
    return (
      <SecondComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const thirdComponent = () => {
    return (
      <ThirdComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fourthComponent = () => {
    return (
      <FourthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const fifthComponent = () => {
    return (
      <FifthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const sixthComponent = () => {
    return (
      <SixthComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const seventhComponent = () => {
    return (
      <SeventhComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} />
    )
  }
  const eightComponent = () => {
    return (
      <EightComponent steps={steps} setSteps={setSteps} setPrevActiveStep={setPrevActiveStep} noriType={2} />
    )
  }
  const ninthComponent = () => {
    return (
      <NinthComponent
        steps={steps}
        noriStatus={noriStatus}
        setPrevActiveStep={setPrevActiveStep}
        npc={npc}
        setNoriStatus={setNoriStatus}
        noriPFactorData={noriPFactorData}
        setNoriPFactorData={setNoriPFactorData}
        noriType={2} />
    )
  }
  const [steps, setSteps] = useState([
    { id: 1, key: 'step1', label: t('views.sellNori.step1'), tooltip: t('views.sellNori.stepDetails1'), isVisited: false, isDone: false, isSelected: true, component: firstComponent },
    { id: 5, key: 'step5', label: t('views.sellNori.step5'), tooltip: t('views.sellNori.stepDetails5'), isVisited: false, selFilterCriteria: [{ id: 1, key: t('views.sellNori.step51'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails51') }, { id: 2, key: t('views.sellNori.step52'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails52') }, { id: 3, key: t('views.sellNori.step53'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails53') }, { id: 4, key: t('views.sellNori.step54'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails54') }, { id: 5, key: t('views.sellNori.step55'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails55') }, { id: 6, key: t('views.sellNori.step56'), min: 0, max: 6, tooltip: t('views.sellNori.stepDetails56') }], isDone: false, isSelected: false, component: fifthComponent },
    { id: 2, key: 'step2', label: t('views.sellNori.step2'), tooltip: t('views.sellNori.stepDetails2'), isVisited: false, selectedNum: [], isDone: false, isSelected: false, component: secondComponent },
    { id: 6, key: 'step6', label: t('views.sellNori.step6'), tooltip: t('views.sellNori.stepDetails6'), isVisited: false, selAdvanceFilterCriteria: [{ id: 1, key: t('views.sellNori.step61'), min: 3, max: 40, dmin: 3, dmax: 40, tooltip: t('views.sellNori.stepDetails61') }, { id: 2, key: t('views.sellNori.step62'), min: 5, max: 41, dmin: 5, dmax: 41, tooltip: t('views.sellNori.stepDetails62') }, { id: 3, key: t('views.sellNori.step63'), min: 1, max: 37, dmin: 1, dmax: 37, tooltip: t('views.sellNori.stepDetails63') }, { id: 4, key: t('views.sellNori.step64'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.sellNori.stepDetails64') }, { id: 5, key: t('views.sellNori.step65'), min: 1, max: 5, dmin: 1, dmax: 5, tooltip: t('views.sellNori.stepDetails65') }, { id: 6, key: t('views.sellNori.step66'), min: 1, max: 6, dmin: 1, dmax: 6, tooltip: t('views.sellNori.stepDetails66') }, { id: 7, key: t('views.sellNori.step67'), min: 0, max: 10, dmin: 0, dmax: 10, tooltip: t('views.sellNori.stepDetails67') }], tolerance: 0, tolTooltip: t('views.sellNori.stepDetails68'), isDone: false, isSelected: false, component: sixthComponent },
    { id: 3, key: 'step3', label: t('views.sellNori.step3'), tooltip: t('views.sellNori.stepDetails3'), isVisited: false, selectedExcludeNum: [], isDone: false, isSelected: false, component: thirdComponent },
    { id: 7, key: 'step7', label: t('views.sellNori.step7'), tooltip: t('views.sellNori.stepDetails7'), isVisited: false, selAppPartiNum: [], quota: 6, isDone: false, isSelected: false, component: seventhComponent },
    { id: 4, key: 'step4', label: t('views.sellNori.step4'), tooltip: t('views.sellNori.stepDetails4'), isVisited: false, selPriGrpNum: [], highPrio: 51, lowPrio: 49, isDone: false, isSelected: false, component: fourthComponent },
    { id: 8, key: 'step8', label: t('views.sellNori.step8'), tooltip: t('views.sellNori.stepDetails9'), isVisited: false, selBlockWiseNum: [{ id: 1, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 2, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 3, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 4, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 5, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 6, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 7, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 8, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 9, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }, { id: 10, numbers: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], selPrioNo: [] }], numOfBlocks: 2, isDone: false, isSelected: false, component: eightComponent },
    { id: 9, key: 'step9', label: t('views.sellNori.step9'), isVisited: false, isDone: false, isSelected: false, component: ninthComponent }
  ])
  const [activeStep, setActiveStep] = useState(steps[0])
  const [npc, setNpc] = useState({})
  const { refetch: refetches } = useQuery('nori-combinations', () => noriCombinations(steps), {
    enabled: false,
    select: (data) => {
      return data?.data
    },
    onSuccess: (data) => {
      data.rcb = data.rcb.toFixed(6)
      setNpc(Object.assign(npc, data))
    },
    onError: () => {
      navigate('/error', { state: { errorMsg: t('views.sellNori.error') } })
    }
  })
  const handleNext = () => {
    const result = [...steps]
    let index = [...steps, ...[]].sort((a, b) => a.id - b.id).find((x) => x.id > activeStep.id && x.isSelected === true)
    if (index === undefined) {
      refetches()
      index = result[8]
    } else {
      setSteps(prevStep => prevStep.map(x => {
        if (x.id === activeStep.id) {
          x.isDone = true
          x.isVisited = true
        }
        return x
      }))
    }
    if (activeStep.id === 9) navigate('/', { state: { ticketState: state?.ticket?.length ? state.ticket : [], currentPoolData: state?.currentPoolData || homeData.currentPoolData } })
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const handleBack = () => {
    const index = [...steps, ...[]].sort((a, b) => b.id - a.id).find(x => activeStep.id - 1 > 1 && x.isSelected === false ? x.id === 1 : x.id < activeStep.id && x.isSelected === true)
    if (index === undefined) return navigate('/', { state: { ticketState: state?.ticket?.length ? state.ticket : [], currentPoolData: state?.currentPoolData || homeData.currentPoolData, ncbTickets: ncbTickets, stepsTickets: stepsTickets } })
    setSteps(prevStep => prevStep.map(x => {
      if (x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(index)
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
  }
  const jumpToStep = (stepNo) => {
    const result = [...steps]
    const findEle = result.findIndex((a) => a.id === stepNo)
    setSteps(prevStep => prevStep.map(x => {
      if (x.id !== stepNo && x.id === activeStep.id) {
        x.isDone = true
        x.isVisited = true
      }
      return x
    }))
    setPrevActiveStep(true)
    setActiveStep(result[findEle])
    setLoading({ ...loading, status: true })
    setTimeout(() => {
      setLoading({ ...loading, status: false })
    }, 300)
    return <ScrollTop />
  }
  return (
    <>
      {loading.status ? <Loading addClass={'active'} /> : ''}
      {prevActiveStep ? <ScrollTop /> : ''}
      <Header activeTab={1} tickets={state?.ticket} currentPoolData={state?.currentPoolData || homeData.currentPoolData} ncbTickets={ncbTickets} stepsTickets={stepsTickets} />
      <div className="stepper-sec">
        <Sidebar sideActiveTab={1} tickets={state?.ticket} currentPoolData={state?.currentPoolData || homeData.currentPoolData} ncbTickets={ncbTickets} stepsTickets={stepsTickets} />
        <div className="box">
          <img src={blueballimg} className='blueballimg' />
          <div className="step-component step-header">
            <div className='steps-left-sec left-header-sec'>
              <h1>{t('views.sellNori.sellANori')}</h1>
              <div className="steps">
                {noriStatus.status === 'inActive' ? <span onClick={() => jumpToStep(1)}>{t('views.sellNori.options')}</span> : <span>{t('views.sellNori.options')}</span>}
                <ul className="nav">
                  {[...steps, ...[]].sort((a, b) => a.id - b.id).map((step, i) => {
                    return (
                      step.id < 9
                        ? <li key={step.id} className={activeStep.id !== 1 && activeStep.id === step.id && step.isVisited === false ? 'activate' : step.isDone ? 'done' : step.isSelected ? 'selected' : ''}>
                          {step.isSelected && step.id !== 1 && noriStatus.status === 'inActive' ? <div onClick={() => jumpToStep(step.id)}><span><a >{step.id}</a></span></div> : <div><span>{step.id}</span></div>}
                        </li>
                        : ''
                    )
                  }
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="step-component">
            <div className='steps-left-sec'>
              <div>
                {activeStep.component()}
              </div>
              <img src={redballimg} className='redballimg' />
              <div className="btn-component">
                {noriStatus.status !== 'active'
                  ? <div>
                    <input type="button" value={steps[0].id === activeStep.id ? t('views.sellNori.menu') : t('views.sellNori.prev')} onClick={handleBack} />
                  </div>
                  : ''}
                <div><input type="button" value={steps[steps.length - 1].id !== activeStep.id ? t('views.sellNori.next') : t('views.sellNori.goMenu')} onClick={handleNext} /> </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer isVisibleBall={false} scoreDate={state?.currentPoolData?.lastWiNs || homeData.lastWiNs} currentPool={state?.currentPoolData?.lastDraws || homeData.lastDraws} graphData={state?.currentPoolData?.lastHundredDraws || homeData.lastHundredDraws} />
    </>
  )
}

export default Sell
